import React from 'react';

export default function BoxWithShadow(props) {
  return <div id="box-with-shadow">{props.children}</div>;
}
